// Bild-Zoom auf der Produktseite: Pfeile, Zähler und Pfeiltasten für Horizons Zoom-Dialog (nur Desktop-Optik,
// die Logik gilt überall). Der Dialog ist der Scroll-Container; ein Bild = eine Bildschirmhöhe (siehe schnorv-pdp.css).
(function () {
  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';

  function setup(dialog) {
    if (dialog.dataset.sLb) return;
    dialog.dataset.sLb = '1';
    var slides = function () { return Array.prototype.slice.call(dialog.querySelectorAll('.dialog-zoomed-gallery > .product-media-container')); };
    var current = function () {
      var top = dialog.scrollTop, h = dialog.clientHeight || 1;
      return Math.max(0, Math.min(slides().length - 1, Math.round(top / h)));
    };
    var goTo = function (i) {
      var list = slides(); if (!list.length) return;
      i = Math.max(0, Math.min(list.length - 1, i));
      list[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    var prev = document.createElement('button'); prev.type = 'button'; prev.className = 's-lb-arrow s-lb-arrow--prev'; prev.setAttribute('aria-label', 'Vorheriges Bild'); prev.innerHTML = ICON_PREV;
    var next = document.createElement('button'); next.type = 'button'; next.className = 's-lb-arrow s-lb-arrow--next'; next.setAttribute('aria-label', 'Nächstes Bild'); next.innerHTML = ICON_NEXT;
    var counter = document.createElement('div'); counter.className = 's-lb-counter'; counter.setAttribute('aria-live', 'polite');
    dialog.appendChild(prev); dialog.appendChild(next); dialog.appendChild(counter);

    var stop = function (e) { e.preventDefault(); e.stopPropagation(); };
    prev.addEventListener('click', function (e) { stop(e); goTo(current() - 1); });
    next.addEventListener('click', function (e) { stop(e); goTo(current() + 1); });

    var update = function () {
      var n = slides().length, i = current();
      counter.textContent = (i + 1) + ' / ' + n;
      prev.disabled = i <= 0; next.disabled = i >= n - 1;
    };
    dialog.addEventListener('scroll', update, { passive: true });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { stop(e); goTo(current() + 1); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { stop(e); goTo(current() - 1); }
    });
    new MutationObserver(function () { if (dialog.open) setTimeout(update, 50); }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    update();
  }

  function init() { document.querySelectorAll('zoom-dialog dialog').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
